var ApiKeyBuilder = /** @class */ (function () {
    function ApiKeyBuilder() {
        this.apiKey = {
            id: 'bob4l1febr0',
            title: 'Bob title',
            secret: 'bob-bobobobobobobob',
            creationDate: 1469614818000,
            lastUpdateDate: 1469614818000
        };
    }
    ApiKeyBuilder.prototype.withId = function (id) {
        this.apiKey.id = id;
        return this;
    };
    ApiKeyBuilder.prototype.withTitle = function (title) {
        this.apiKey.title = title;
        return this;
    };
    ApiKeyBuilder.prototype.withCreationDate = function (creationDate) {
        this.apiKey.creationDate = creationDate;
        return this;
    };
    ApiKeyBuilder.prototype.withLastUpdateDate = function (lastUpdateDate) {
        this.apiKey.lastUpdateDate = lastUpdateDate;
        return this;
    };
    ApiKeyBuilder.prototype.withSecret = function (secret) {
        this.apiKey.secret = secret;
        return this;
    };
    ApiKeyBuilder.prototype.withPermissionsData = function (permissionsData) {
        this.apiKey.permissionsData = permissionsData;
        return this;
    };
    ApiKeyBuilder.prototype.build = function () {
        return this.apiKey;
    };
    return ApiKeyBuilder;
}());
export { ApiKeyBuilder };
//# sourceMappingURL=api-key.builder.js.map